module.exports = __webpack_public_path__ + "static/media/warning.71c53efc.svg";